import React, { useState } from 'react';
import { ArrowLeft, ShoppingBag, Backpack } from 'lucide-react';
import { Marketplace } from './Marketplace';
import { Inventory } from './Inventory';
import { LoadingSpinner } from '../ui/LoadingSpinner';
import type { User } from '../../types/user';

interface TrainingGroundsProps {
  onBack: () => void;
  user: User | null;
}

export function TrainingGrounds({ onBack, user }: TrainingGroundsProps) {
  const [activeTab, setActiveTab] = useState<'marketplace' | 'inventory'>('marketplace');
  const [isLoading, setIsLoading] = useState(true);

  React.useEffect(() => {
    // Initial load delay
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-amber-900 text-amber-100 p-8 bg-[url('https://images.unsplash.com/photo-1578662996442-48f60103fc96?auto=format&fit=crop&q=80')] bg-cover bg-center bg-blend-overlay">
        <div className="max-w-6xl mx-auto flex justify-center items-center min-h-[60vh]">
          <LoadingSpinner />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-amber-900 text-amber-100 p-8 bg-[url('https://images.unsplash.com/photo-1578662996442-48f60103fc96?auto=format&fit=crop&q=80')] bg-cover bg-center bg-blend-overlay">
      <div className="max-w-6xl mx-auto">
        <button
          onClick={onBack}
          className="flex items-center gap-2 text-yellow-500 hover:text-yellow-400 mb-6"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Kingdom
        </button>

        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold font-serif mb-4 bg-gradient-to-r from-yellow-500 to-amber-500 text-transparent bg-clip-text">
            {activeTab === 'marketplace' ? 'Mystical Marketplace' : 'Royal Treasury'}
          </h1>
          <p className="text-xl text-amber-200 font-serif">
            {activeTab === 'marketplace' 
              ? 'Acquire legendary creatures and enchanted artifacts'
              : 'Your collection of mystical creatures and enchanted artifacts'}
          </p>
        </div>

        <div className="flex gap-4 mb-8">
          <button
            onClick={() => setActiveTab('marketplace')}
            className={`flex-1 flex items-center justify-center gap-2 px-6 py-3 rounded-lg font-serif
              ${activeTab === 'marketplace' 
                ? 'bg-gradient-to-r from-yellow-600 to-amber-500 text-white' 
                : 'bg-gray-800 text-amber-200 hover:bg-gray-700'}`}
          >
            <ShoppingBag className="w-5 h-5" />
            Marketplace
          </button>
          <button
            onClick={() => setActiveTab('inventory')}
            className={`flex-1 flex items-center justify-center gap-2 px-6 py-3 rounded-lg font-serif
              ${activeTab === 'inventory'
                ? 'bg-gradient-to-r from-yellow-600 to-amber-500 text-white'
                : 'bg-gray-800 text-amber-200 hover:bg-gray-700'}`}
          >
            <Backpack className="w-5 h-5" />
            Inventory
          </button>
        </div>

        {activeTab === 'marketplace' ? (
          <Marketplace user={user} />
        ) : (
          <Inventory user={user} onBack={onBack} />
        )}
      </div>
    </div>
  );
}